import React, { Component, PropTypes } from 'react';
import {reduxForm} from "redux-form";
import {GetUser, GetInfoOneUser, DelUser, editUser} from '../../actions/index';
import {Link} from 'react-router';

class UsersEdit extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.renderPass = this.renderPass.bind(this);
        this.delUser = this.delUser.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.SubmitForm = this.SubmitForm.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetInfoOneUser(this.props.params.id, token);
    }
    componentDidMount(){
        let that = this;
        $('.datapickers').datepicker({
            language: 'en',
            format: "yyyy-mm-dd",
            autoclose: true
        }).on('hide', function(e){
            let  dateObject = $(this).val();
            that.props.fields[e.target.name].onChange(dateObject);
            $(this).datepicker('hide');
        });
    }
    SubmitForm(props){
        let token = localStorage.getItem('id_token_admin');
        props.info = {};
        props.info.birthday = props.birthday;
        props.info.gender = props.gender;
        delete props.birthday;
        delete props.gender;
        this.props.editUser(token, props, this.props.params.id).then((response)=>{
            if(response.payload.status == 200){
                this.context.router.push('/users');
            }
        })
    }
    delUser(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DelUser(token, this.props.params.id).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal()
                this.context.router.push('/users');
            }
        });
    }
    delAdminOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        $('#DelAdmin').modal('show');
    }
    closeModal(){
        $('#DelAdmin').modal('hide');
    }
    renderPass(){
        const chars = "abcdefghijklmnopqrstuvwxyz1234567890";
        let pass = "";
        for (let x = 0; x < 9; x++) {
            let i = Math.floor(Math.random() * chars.length);
            pass += chars.charAt(i);
        }
        this.props.fields.password.onChange(pass);
    }
    componentWillUnmount(){
        this.props.user.user_edit = {};
    }
    render() {
        const { fields: {
            first_name,
            email,
            password,
            gender,
            birthday}, handleSubmit} = this.props;
        return (
            <div className="dashboard-wrapper">
                {this.props.user.user_edit ? <p className="dashboard-title">{this.props.user.user_edit.first_name} {this.props.user.user_edit.last_name}</p> : ''}
                <form onSubmit={handleSubmit(this.SubmitForm.bind(this))} id="userEdits">
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className="block-4-8-title">
                                <p><span className="glyphicon glyphicon-info-sign" aria-hidden="true"></span>Info</p>
                            </div>
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="first_name">First Name</label>
                                </div>
                                <div className={ first_name.touched && !first_name.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                    <input type="text"
                                           placeholder="First Name"
                                           className="form-control"
                                           name="first_name"
                                           id="first_name"
                                        {...first_name}
                                    />
                                </div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4">
                                    <label htmlFor="gender">Gender</label>
                                </div>
                                <div className="col-md-4">
                                    <select className="form-control" {...gender} data-live-search="true">
                                        <option value="unknown" >Choose</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4">
                                    <label htmlFor="birthday">Birthday</label>
                                </div>
                                <div className={ birthday.touched && !birthday.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                    <input data-provide="datepicker" className="form-control datapickers" placeholder="yyyy-mm-dd" {...birthday} />
                                </div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4">
                                    <label htmlFor="email">Email</label>
                                </div>
                                <div className={ email.touched && !email.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                    <input type="email"
                                           placeholder="Email"
                                           className="form-control"
                                           name="email"
                                           id="email"
                                        {...email}
                                    />

                                </div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4">
                                    <label htmlFor="password">Password</label>
                                </div>
                                <div className={ password.touched && !password.valid ? 'col-md-2 has-error' : 'col-md-2'}>
                                    <input type="text"
                                           placeholder="Password"
                                           className="form-control"
                                           name="password"
                                           id="password"
                                           disabled
                                        {...password}
                                    />

                                </div>
                                <div className="col-md-2">
                                    <button type="button" onClick={this.renderPass} className="btn btn-primary">Generate new password</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className="block-4-8-title">
                                <p><span className="glyphicon glyphicon-book" aria-hidden="true"></span>Language</p>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4">
                                    <label>Learning languages</label>
                                </div>
                                <div className="col-md-4 text-grey"><span>English, Spanish, Russian(subscribe)</span></div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4">
                                    <label>Base languages</label>
                                </div>
                                <div className="col-md-4 text-grey"><span>French</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className="block-4-8-title">
                                <p><span className="glyphicon glyphicon-signal" aria-hidden="true"></span>In progress</p>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-12"><span>English</span></div>
                                <div className="col-md-4 text-grey"><span>Test result:</span></div>
                                <div className="col-md-4 text-grey"><span className="test-done">20</span><span className="test-error">/10</span></div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4 text-grey"><span>Current position <span>(Study)</span>:</span></div>
                                <div className="col-md-4"><span >1556</span><span >/4000</span></div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-12"><span>Spanish:</span></div>
                                <div className="col-md-4 text-grey"><span>Test result:</span></div>
                                <div className="col-md-4"><span>0</span><span >/20</span><span className="text-grey">&nbsp; test not passed</span></div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4 text-grey"><span>Current position <span>(Study)</span>:</span></div>
                                <div className="col-md-4"><span >1556</span><span >/4000</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className="block-4-8-title">
                                <p><span className="glyphicon glyphicon-flag" aria-hidden="true"></span>Activity</p>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4"><span>How long has user been online</span></div>
                                <div className="col-md-4 text-grey"><span>2 hours 45 min</span></div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4"><span>How much daily</span></div>
                                <div className="col-md-4 text-grey"><span>21 min</span></div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4"><span>Time of the active learning period</span></div>
                                <div className="col-md-4 text-grey"><span>1 hours 45 min</span></div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-4"><span>Login times (5 last logins)</span></div>
                                <div className="col-md-4 text-grey">
                                    <p>18.07.2016 10:45am</p>
                                    <p>18.07.2016 10:45am</p>
                                    <p>18.07.2016 10:45am</p>
                                    <p>18.07.2016 10:45am</p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className="block-4-8-title">
                                <p><span className="glyphicon glyphicon-credit-card" aria-hidden="true"></span>Subscription</p>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-12"><span>English</span></div>
                                <div className="col-md-4 text-grey"><span>6 month package</span></div>
                                <div className="col-md-4"><span>expiry date - 1 day 22</span></div>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-12"><span>Spanish</span></div>
                                <div className="col-md-4 text-grey"><span>Trial period</span></div>
                                <div className="col-md-4"><span>expiry date - 1 day 22</span></div>
                            </div>
                            <div className="block-4-8-title">
                                <p>&nbsp;</p>
                            </div>
                            <div className="clearfix">
                                <div className="col-md-12"><span>Payment history</span></div>
                            </div>
                            <div className="col-md-12">
                                <div className="history-list history-list-header clearfix">
                                    <p>#</p>
                                    <p>Date</p>
                                    <p>Package</p>
                                    <p>Language</p>
                                    <p>Sum</p>
                                    <p>Expiry date</p>
                                </div>
                                <div className="history-list clearfix">
                                    <p>1</p>
                                    <p>15.01.2016 11:23</p>
                                    <p>Trial period</p>
                                    <p>English</p>
                                    <p className="text-grey">0 $</p>
                                    <p className="text-grey">15.01.2016 11:23</p>
                                </div>
                            </div>
                        </div>
                        <div className="white-block clearfix">
                            <div className="col-md-12 text-center button-group">
                                <Link to={"users"} className="btn btn-default">Back</Link>
                                <button  onClick={this.delAdminOpenModal} disabled={this.props.params.id ? '' : "disabled"} type="button" className="btn btn-danger">Delete</button>
                                <button type="submit" className="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </form>

                <div className="modal fade" id="DelAdmin" tabIndex="-1" role="dialog" aria-labelledby="DelAdminLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelAdmin"></span>
                                <p>Do you really want to delete user {this.props.user.user_edit ? <span>{this.props.user.user_edit.first_name} {this.props.user.user_edit.last_name}</span> : ""}?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delUser} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="clearfix"></div>
            </div>
        );
    }
}

function validate(values) {
    const errors = {};
    if(!values.first_name){
        errors.first_name = 'Enter a first_name'
    }
    if(!values.email){
        errors.email = 'Enter a email'
    }
    if(!values.password){
        errors.password = 'Enter a title'
    }
    if(!values.birthday){
        errors.birthday = 'Enter a title'
    }
    if(!values.gender){
        errors.gender = 'Enter a title'
    }
    return errors;
}

function  mapStateToProps(state) {
    return{
        user: state.user,
        dashboard: state.dashboard,
        initialValues: {
            first_name: state.user.user_edit.first_name || '',
            email: state.user.user_edit.email || '',
            password: state.user.user_edit.password || '',
            birthday: state.user.user_edit.info ? state.user.user_edit.info.birthday : '',
            gender: state.user.user_edit.info ? state.user.user_edit.info.gender : ''
        }
    }
}
export default reduxForm({
    form: 'Edit User',
    fields: ['first_name', 'email', 'password', 'birthday', 'gender'],
    validate
}, mapStateToProps, {GetUser, GetInfoOneUser, DelUser, editUser})(UsersEdit);



// WEBPACK FOOTER //
// ./src/components/user/usersEdit.js